import { render, staticRenderFns } from "./WineProductDetails.vue?vue&type=template&id=4083ae76&scoped=true"
import script from "./WineProductDetails.vue?vue&type=script&lang=js"
export * from "./WineProductDetails.vue?vue&type=script&lang=js"
import style0 from "./WineProductDetails.vue?vue&type=style&index=0&id=4083ae76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4083ae76",
  null
  
)

export default component.exports